// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2fe-n","modalFooterButton":"ModalNotes_modalFooterButton__1LzgO"};